type ShareLightProps = {
  color?: string
}

function ShareLight({ color = '#777' }: ShareLightProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-label="공유"
    >
      <desc>공유</desc>
      <defs>
        <clipPath id="j0vm8zlzra">
          <path
            fill="#fff"
            stroke={color}
            d="M0 0h20v20H0z"
            data-name="사각형 3303"
            transform="translate(1432.5 570.5)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath="url(#j0vm8zlzra)"
        data-name="마스크 그룹 98"
        transform="translate(-1432.5 -570.5)"
      >
        <g data-name="share-2 (1)">
          <path
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
            d="M1444 585.1a2 2 0 112 2 2 2 0 01-2-2zm-4.239-3.6a2 2 0 11.239-.95 2 2 0 01-.24.951l4.52 2.568zm4.479-4.549A2 2 0 111446 578a1.99 1.99 0 01-1.76-1.049l-4.513 2.568z"
            data-name="합치기 92"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default ShareLight
